module.exports = __webpack_public_path__ + "assets/img/923032.135df93e.jpg";